import { AgGridReact } from "ag-grid-react"

export default (props) => {

    return <div className="ag-theme-alpine" style={{ width: '100%', height: '250px' }}>
        <AgGridReact rowData={props.rowData} columnDefs={props.columnDefs} defaultColDef={props.defaultColDef} >
        </AgGridReact>
    </div>
}